import { render, staticRenderFns } from "./AccountCheckPopup.vue?vue&type=template&id=cb530740&scoped=true&"
import script from "./AccountCheckPopup.vue?vue&type=script&lang=js&"
export * from "./AccountCheckPopup.vue?vue&type=script&lang=js&"
import style0 from "./AccountCheckPopup.vue?vue&type=style&index=0&id=cb530740&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb530740",
  null
  
)

export default component.exports